export const frontendSkills = [
  "HTML",
  "CSS",
  "React",
  "React-native",
  "React-query",
  "Redux",
  "React-testing-library",
  "React-hook-forms",
  "Formik",
  "Styled-components",
  "Storybook",
  "React-admin",
  "Gatsby",
  "Next.js",
];

export const backendSkills = [
  "Node.js",
  "Express.js",
  "PostgreSQL",
  "Sequelize",
  "AWS",
  "email-templates",
  "dbdiagram.io",
  "Cron",
  "Graphile-worker",
  "Mocha",
  "Chai",
  "sinon",
];

export const commonSkills = [
  "JavaScript",
  "TypeScript",
  "Docker",
  "REST",
  "Git",
  "Github",
  "Jira",
  "VSCode",
  "Cursor",
  "Github Copilot",
  "ChatGPT",
  "Claude",
  "Figma",
  "Postman",
  "lexorank",
  "Amplitude",
  "ConfigCat",
];
